import { CapitalizeOnlyFirstLetter } from "../../Helper/string.helper";
import { Students } from "../../Models/students.models";
import { getValue } from "../../utils/object.utils";

export const transformStudentsListTableData = (
  studentsList: Array<Students>
) => {
  const transformDatForTable = studentsList.map((student: Students) => ({
    id: student.id,
    name: student.full_name,
    class: getValue(student, "class.name", "N/A"),
    gender: CapitalizeOnlyFirstLetter(student.gender),
    DOB: student.date_of_birth,
    fathersName: getValue(student, "father_info.name", "N/A"),
    mothersName: getValue(student, "mother_info.name", "N/A"),
    regno: getValue(student, "regno", "N/A"),
  }));

  return transformDatForTable;
};
